import * as React from 'react';
import { compose, withState, withHandlers } from 'recompose';
import { Auth, Cache } from 'aws-amplify';
import Routes from '../../constants/Routes';
import { withRouter } from 'react-router';
import { withLoggedInRedirect } from '../../helpers/withLoggedInRedirect';
import MainLayout from '../Layouts/MainLayout';

type Props = {
  username: string;
  password: string;
  email: string;
  phone: string;
  updateUsername: () => void;
  updatePassword: () => void;
  updateEmail: () => void;
  updatePhone: () => void;
  register: () => void;
};

const Signup: React.SFC<Props> = ({
  username,
  password,
  email,
  phone,
  updateUsername,
  updatePassword,
  updateEmail,
  updatePhone,
  register,
}) => (
  <MainLayout>
    <p>Signup</p>
    <form onSubmit={register}>
      <input type="text" value={username} onChange={updateUsername} placeholder="Username" />
      <br />
      <input type="password" value={password} onChange={updatePassword} placeholder="Password" />
      <br />
      <input type="text" value={email} onChange={updateEmail} placeholder="Email" />
      <br />
      <input type="text" value={phone} onChange={updatePhone} placeholder="Phone" />
      <br />
      <button type="submit">Signup</button>
    </form>
  </MainLayout>
);

export default compose(
  withRouter,
  withLoggedInRedirect,
  withState('username', 'setUsername', ''),
  withState('password', 'setPassword', ''),
  withState('email', 'setEmail', ''),
  withState('phone', 'setPhone', ''),
  withHandlers({
    updateUsername: ({ setUsername }) => (event: React.FormEvent<HTMLInputElement>) =>
      setUsername(event.currentTarget.value),
    updatePassword: ({ setPassword }) => (event: React.FormEvent<HTMLInputElement>) =>
      setPassword(event.currentTarget.value),
    updateEmail: ({ setEmail }) => (event: React.FormEvent<HTMLInputElement>) =>
      setEmail(event.currentTarget.value),
    updatePhone: ({ setPhone }) => (event: React.FormEvent<HTMLInputElement>) =>
      setPhone(event.currentTarget.value),
    register: ({ username, password, email, phone, history }) => async (
      event: React.FormEvent<HTMLInputElement>,
    ) => {
      event.preventDefault();
      try {
        const user = await Auth.signUp({
          username,
          password,
          attributes: {
            email,
            phone_number: phone,
          },
        });
        Cache.setItem('registerUsername', username);
        history.push(Routes.confirmSignup);
        console.log('signup', user);
      } catch (error) {
        console.log('ERROR:register', error);
      }
      console.log('register', username, password, email, phone);
    },
  }),
)(Signup);



// WEBPACK FOOTER //
// ./src/containers/Auth/Signup.tsx